import type {ReactElement} from 'react';

const artworkSources = {
  library: new URL('../../assets/library-robot-sample.png', import.meta.url).href,
  motion: new URL('../../assets/fragrance-campaign.png', import.meta.url).href,
  project: new URL('../../assets/project-lab-sample.png', import.meta.url).href
};

interface PreviewFrameProps {
  readonly artwork?: keyof typeof artworkSources;
  readonly className?: string;
  readonly index?: number;
  readonly label?: string;
}

// Editorial artwork identifies a demo placeholder; it is never a generation result.
export const PreviewFrame = ({artwork = 'motion', className = '', label = 'Illustrative artwork — not generated output'}: PreviewFrameProps): ReactElement => {
  const imageClassName = artwork === 'motion' ? 'object-top' : 'scale-110 object-center';
  return (
    <div aria-label={label} className={`relative h-full min-h-32 w-full overflow-hidden ${artwork === 'motion' ? 'bg-[#30202c]' : 'bg-[#05212c]'} ${className}`} role="img">
      <img alt="" className={`h-full w-full object-cover ${imageClassName}`} src={artworkSources[artwork]} />
    </div>
  );
};
